export default __webpack_public_path__ + "static/interior-1026449_1920-bca7119236285cfe0e32ac38ac81a55a.png";